import React, { FC } from 'react';
import Image, { ImageProps } from 'components/commercetools-ui/atoms/image';
import Link from 'components/commercetools-ui/atoms/link';
import { Reference } from 'types/reference';

export interface Props {
  logo: ImageProps;
  logoLink: Reference;
  className?: string;
  imageClassName?: string;
  onClick?: () => void;
}

const HeaderLogo: FC<Props> = ({ logoLink, logo, imageClassName, className = '', onClick }) => {
  const title = logo?.title ? Object.values(logo?.title)[0] : '';
  return (
    <div className={`relative md:mt-0 ${className}`} onClick={onClick}>
      <Link className={imageClassName} link={logoLink}>
        <Image media={logo?.media} style={{ objectFit: 'contain' }} alt={title} title={title} className="h-full" />
      </Link>
    </div>
  );
};

export default HeaderLogo;
